import React, { useState, useEffect, useContext } from 'react'
import LogsHeader from './LogsHeader'
import LogsInner from './LogsInner'
import LogsFooter from './LogsFooter'
import { appContext } from '../../../../../../App'
import { getLogs } from '../../../../ReportsFunctions'

export const logsControllerContext = React.createContext()

function useLogsController(props) {
  const app = useContext(appContext)
  const [logs, setLogs] = useState(null)

  useEffect(() => {
    const init = async () => { setLogs(await getLogs(app, parseInt(props.nol))) }
    init()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return ({
    app,
    logs: [logs, setLogs]
  })
}

function LogsController(props) {
  const logsController = useLogsController(props)

  return (
    <React.Fragment>
      <logsControllerContext.Provider value={ logsController }>
        <LogsHeader />
        <LogsInner />
        <LogsFooter />
      </logsControllerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(LogsController)